import React from "react";
import HeroSection from "./HeroSection";
import ProductCategories from "./ProductCategories";
import SmallSlider from "./SmallSlider";
import ProductSection from "./ProductSection";
import EventSection from "./EventSection";
import ReviewSection from "./ReviewSection";
import InformationSection from "./InformationSection";
import PopupBanner from "./PopupBanner";

const HomeContent = () => {
  return (
    <div>
      {/* Pop up banner */}
      <PopupBanner />

      {/* show all the ads video in hero section */}
      <HeroSection />

      {/* show product category */}
      <ProductCategories />

      {/* small ads slider */}
      {/* <SmallSlider /> */}

      {/* show all the products */}
      {/* <ProductSection /> */}

      {/* show latest event ads */}
      {/* <EventSection /> */}

      {/* show best review */}
      <ReviewSection />

      {/* general information consists contact us */}
      <InformationSection />
    </div>
  );
};

export default HomeContent;
